import { useFetch } from '@/composables/fetch.js'
import { defineStore } from 'pinia'
import AppI18n from '@/i18n.js'

export const useAppStore = defineStore('app', {
  state: () => ({
    config: null,
    locales: null,
    modules: [],
    maxUsers: 1,
    uiScale: 100,
    language: null,
  }),
  persist: { pick: ['uiScale', 'language'] },
  actions: {
    /**
     * @returns {Promise<void>}
     */
    async init() {
      this.config = await useFetch('GET', `/config.json`)
      this.locales = await useFetch('GET', `/locales.json`)

      // Load messages, then apply the persisted user language (falls back to config).
      Object.keys(this.locales).forEach(locale => {
        AppI18n.global.setLocaleMessage(locale, this.locales[locale])
      })
      AppI18n.global.locale.value = this.language || this.getConfigValue('LOCALE')
    },

    /**
     * Set and persist the active language, applying it to i18n immediately.
     * @param language
     */
    setLanguage(language) {
      if (!language) {
        return
      }
      this.language = language
      AppI18n.global.locale.value = language
    },
    /**
     * @param key
     * @param defaultValue
     * @returns {*|null}
     */
    getConfigValue(key, defaultValue = null) {
      return this.config[key] ?? defaultValue
    },

    hasModule(module) {
      return this.modules.includes(module)
    },

    /**
     * Sets the UI scale (percent) and applies it immediately.
     * @param scale
     */
    setUiScale(scale) {
      this.uiScale = scale
      this.applyUiScale()
    },

    /**
     * Applies the current UI scale by setting the root font-size. Because the
     * UI is rem-based, this scales text and layout proportionally.
     */
    applyUiScale() {
      document.documentElement.style.fontSize = `${this.uiScale}%`
    }
  }
})